import React from 'react';
import PropType from 'prop-types';

export default function Icon({
  size, color, codePoint = '0x000', blackBg, className,
}) {
  let iconClassName = `icon ${className || ''}`;
  if (size === 'large') {
    iconClassName = `${iconClassName} is-large`;
  } else if (size === 'medium') {
    iconClassName = `${iconClassName} is-medium`;
  } else if (size === 'small') {
    iconClassName = `${iconClassName} is-small`;
  } else if (size === '24') {
    iconClassName = `${iconClassName} is-24`;
  } else if (size === '32') {
    iconClassName = `${iconClassName} is-32`;
  } else if (size === '36') {
    iconClassName = `${iconClassName} is-36`;
  }
  return (
    <div className={iconClassName} style={{ color }}>
      <i className={`icon-content ${blackBg ? 'has-background' : ''}`}>
        <span>{String.fromCodePoint(codePoint)}</span>
      </i>
    </div>
  );
}

Icon.defaultProps = {
  size: null,
  color: '#000',
  blackBg: false,
  className: null,
};
Icon.propTypes = {
  size: PropType.string,
  color: PropType.string,
  blackBg: PropType.bool,
  className: PropType.string,
  codePoint: PropType.string.isRequired,
};
